import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'map-drawer',
    templateUrl: './map-drawer.component.html',
    styleUrls: ['./map-drawer.component.scss']
})
export class MapDrawerComponent {
    constructor() { }

    @Input() width = '100%';
    @Input() mapEvent: google.maps.Map;
    @Input() data: any;
    @Output() onFilter = new EventEmitter<string>();
    @Output() onItemSelected = new EventEmitter<any>();

    drawerOpen: boolean = true;
    isTransitioning = false;

    filter(value: string) {
        this.onFilter.emit(value);
    }

    selectItem(value: any) {
        this.onItemSelected.emit(value);
    }
}